import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const noomSummit = createSlice({
  name: "noomSummit",
  initialState: {
    purchasedNoomSummit: false,
    skippedNoomSummit: false,
  },
  reducers: {
    setPurchasedNoomSummit(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        purchasedNoomSummit: action.payload,
      };
    },
    setSkippedNoomSummit(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        skippedNoomSummit: action.payload,
      };
    },
  },
});

export const { setPurchasedNoomSummit, setSkippedNoomSummit } =
  noomSummit.actions;

export default noomSummit;
